import { Component, Input, OnInit } from '@angular/core';
import { TravelReport } from 'src/app/client-management/parc-management';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
import { ActivityVehiculeClassificationsService } from '../../activity-vehicule-classifications.service';
const Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);

@Component({
  selector: 'app-classification-kmchart',
  templateUrl: './classification-kmchart.component.html',
  styleUrls: ['./classification-kmchart.component.css']
})
export class ClassificationKMChartComponent implements OnInit {


  classments: TravelReport[] = [];
  classmentObject: Object | null = null;

  @Input()
  set activities(activities: TravelReport[]) {
    if (activities) {
      this.classments = Object.assign(activities);
        this.classmentChart();
    }
  }

  constructor(private chartConfig : ChartConfigService,
    private classificationService:ActivityVehiculeClassificationsService) { }

  ngOnInit() {
      this.classmentChart();
  }

  classmentChart() {
    this.chartConfig.setHighCartsLang();

    var seriesData = [];

    for (let classment of this.classments) {
      seriesData.push({name:classment.driverFullName,y:classment.distanceDriven,color: this.classificationService.getColorFromName(classment.driverFullName) , avatarUri: classment.avatarUri})
    }
    const values = this.classments.map(c => c.distanceDriven);
    const minValue = Math.min(...values.filter(v => v > 0));
    const maxValue = Math.max(...values);
    const minPointLength = minValue === 0 ? 0 : 4;
    this.classmentObject = {
      chart: {
        type: 'column'
      },
      title: {
        text: 'KM',
        align: 'center',
        style: {
          fontWeight: 'bold'
        }
      },
      xAxis: {
        type: 'category',

        labels: {
          rotation: -45,
          step: 1,
          style: {
            color: "#000000",
            fontWeight: 'bold',
            textDecoration: "underline"
          }
        }
      },
      yAxis: {
        min: minValue * 0.95,
        max: maxValue * 1.05,
        title: {
          text: 'Σ.KM'
        },
        labels: {
          enabled: false
        }
      },
      legend: {
        enabled: false
      },
      accessibility: {
        point: {
          valueSuffix: 'Σ.KM'
        }
      }, credits: {
        enabled: false
      },
      tooltip: {
        useHTML: true,
        formatter: function(this: any): string {
          const avatar = this.point.avatarUri ? this.point.avatarUri : '';
          return `
            <div style="display:flex; align-items:center;">
              <img src="${avatar}" style="width:40px; height:40px; border-radius:50%; margin-right:5px;" />
              <div>
                <b>${this.point.name}</b><br/>
                ${this.point.y.toFixed(2)} KM
              </div>
            </div>
          `;
        }
      },
      plotOptions: {
        column: {
          borderRadius: 5,
          minPointLength: minPointLength
        },
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{point.y:.2f} '
          }
        }
      },
      series: [{
        colorByPoint: true,
        data: seriesData
      }]
    }
    Highcharts.chart('classmentKMObject', this.classmentObject);
  }

}
